/**
 * Compose the validation error message
 *
 * @param errors {array} The validation errors
 *
 * @returns {string} The validation error message formatted in html format
 */
window.composeValidationError = function (errors) {
    let errorMessage = '';
    $.each(errors, function (i, fieldErrors) {
        $.each(fieldErrors, function (j, fieldError) {
            errorMessage += fieldError;
            if (fieldErrors.length > 1 && j < fieldErrors.length - 1) {
                errorMessage += '</br>';
            }
        });
        errorMessage += '</br>';
    });
    return errorMessage;
}

window.showInvalidFeedback = function (jqXHR, selectorAlerts, selectorForm) {
    if (jqXHR.status === 422) {
        $.each(jqXHR.responseJSON.errors, function (i, fieldErrors) {
            let errorMessage = '';
            $.each(fieldErrors, function (j, fieldError) {
                if (fieldErrors.length > 1 && j > 0) {
                    errorMessage += '</br>';
                }
                errorMessage += fieldError;
            });
            // @DISCLAIMER
            const nombreCampo = i.charAt(0).toUpperCase() + i.slice(1).replace(/\./g, "_");
            $(`#${selectorForm}Campo${nombreCampo}Feedback`)
                .show()
                .html(errorMessage)
                .parent()
                .find(`[aria-describedby='${selectorForm}Campo${nombreCampo}Feedback']`)
                .addClass('is-invalid');
            if ($(`#${selectorForm}Campo${nombreCampo}Feedback`).hasClass('invalid-feedback-group')) {
                $(`#${selectorForm}Campo${nombreCampo}Feedback`)
                    .parent()
                    .find(`[aria-describedby='${selectorForm}Campo${nombreCampo}Feedback']`)
                    .parent()
                    .addClass('is-invalid');
            }
            // TODO: Poner el focus sobre el primer elemento erroneo!
        });

        $(`#${selectorAlerts}Error`)
            .show()
            .find('span')
            .text(transAccionCamposIncorrectos);
    } else if (jqXHR.responseJSON.message) {
        $(`#${selectorAlerts}Error`)
            .show()
            .find('span')
            .text(jqXHR.responseJSON.message);
    }
    slideToElement(`#${selectorAlerts}Error`);
}

window.cleanFeedback = function (selectorAlerts, selectorForm) {
    $(`#${selectorAlerts}Error, #${selectorAlerts}Exito`).hide();
    $(`#${selectorForm} .invalid-feedback`).hide();
    $(`#${selectorForm} input, #${selectorForm} textarea`).removeClass('is-invalid');
}
